<template>
  <div id="app">
    <headers ref="header" :scrollTop="scrollTop" :language="language"></headers>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

import headers from './components/header.vue'
// import { company } from '@/request/api'
export default {
  components: {
    // footerBotom,
    headers
  },
  name: "App",
  data() {
    return {
      scrollTop: 0,
      isRouterAlive: true,
      language: 'Chinese',
      inLanguage:'en'
    }
  },
  created() {
    const browserLanguage = navigator.language || navigator.userLanguage
    let domain = window.location.hostname;
    let main =  domain.endsWith('www.antai-energy.com')
    if (browserLanguage != this.inLanguage && main) {
      window.location.href="http://cn.antai-energy.com"
    }
    // this.getCompany()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    reload() {
      // 通过 this.isRouterAlive 控制 router-view 达到刷新效果
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
    },
    // getCompany() {
    //   company({}).then(res => {
    //     if (res.code == 1) {
    //       localStorage.setItem('info', JSON.stringify(res.data))
    //       location.href="#"
    //     }
    //   })
    // }
  }
};
</script>

<style>
* {
  transition: 0.5s
}

html,
body,
p {
  font-family: 'pingfang SC', arial, 'helvetica neue', 'SYSTM', 'microsoft yahei ui', 'microsoft yahei', 'simsun', sans-serif;
  margin: 0;
  padding: 0;
}

img {
  vertical-align: bottom;
}

ul {
  list-style: none;
  margin: 0;
  display: flex;
  display: -webkit-box;
  /* align-ite; */
}

li {
  list-style-type: none;
  text-align: center;
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

a:visited {
  color: inherit;
  text-decoration: none;
}

a:active {
  color: inherit;
  text-decoration: none;
}

.product {
  max-width: 1440px;
  margin: 0 auto;
}

.product-cont {
  padding: 60px 60px;
}

@media screen and (max-width:767px) {
  .product {
    /* padding: 0 15px; */
    margin: 0 auto;
  }

  .product-cont {
    padding: 15px 15px;
  }
}

.product-image .images:hover {
  transform: scale(1.2);
}

.button-hover:hover {
  opacity: 0.8;
}

.animated-fadeInUp {
  animation-name: fadeInUp;
  /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
  animation-duration: 3s;
}
.animated-fadeInUpx {
  animation-name: fadeInUpx;
  /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
  animation-duration: 1.6s;
}
.animated-fadeInUp1 {
  animation-name: fadeInUpx;
  /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
  animation-duration: 1s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue